import { FC } from 'react';
import { useDocumentsList } from '../../context/DocumentsListPageContext';
import DefaultListRow from './DefaultListRow';

const DefaultListBody: FC = () => {
  const { data } = useDocumentsList();

  const documents = data.documents || [];

  return documents.map((doc, index) => (
    <DefaultListRow key={doc._id} index={index} document={doc} />
  ));
};

export default DefaultListBody;
